
import { defineComponent } from "vue";
import TemplateUpdate from "./TemplateUpdate.vue";

export default defineComponent({
  name: "settlement-entity-overview",
  components: { TemplateUpdate },
});
